<ion-header class="modal-header">
  <div class="modal-title">
    <h3>{{ id ? 'Edit Topic' : 'Add Topic' }}</h3>
  </div>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button fill="clear" shape="round" class="close-button" (click)="dismiss()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-card>
    <ion-card-header>
      <ion-card-title>Topic description</ion-card-title>
    </ion-card-header>
    <ion-card-content>
      <ion-label class="input-label"> Name </ion-label>
      <ion-input #nameInput placeholder="e.g. IT Support Request" [(ngModel)]="name" class="input-field"> </ion-input>
      <ion-label class="input-label"> Description </ion-label>
      <ion-textarea
        #descriptionInput
        placeholder="e.g. Issues related to information technology and hardware"
        [(ngModel)]="description"
        class="input-field"
        rows="3"
        [autoGrow]="true"
      >
      </ion-textarea>
    </ion-card-content>
  </ion-card>

  <ion-card>
    <ion-card-header>
      <ion-card-title>Instructions</ion-card-title>
    </ion-card-header>
    <ion-card-content>
      <ion-label class="input-label">
        User-provided model instructions
        <ion-icon
          name="information-circle"
          class="icon-padded-left"
          ngxTippy
          data-tippy-content="Instructions for the model"
        ></ion-icon>
      </ion-label>
      <ion-textarea [(ngModel)]="instructions" class="input-field" rows="3" [autoGrow]="true"></ion-textarea>
    </ion-card-content>
  </ion-card>

  <ion-card>
    <ion-card-header>
      <ion-card-title> Tools </ion-card-title>
    </ion-card-header>
    <ion-card-content>
      <ion-card *ngFor="let tool of tools; let i = index; trackBy: arrayTrackBy">
        <ion-card-header class="flex-space-between" style="margin-bottom: -16px">
          <ion-card-subtitle style="margin-top: 10px">{{ tool?.automation?.name ?? 'Automation' }}</ion-card-subtitle>
          <ion-button fill="clear" color="dark" (click)="removeAutomation(tool)">
            <ion-icon name="trash-outline"></ion-icon>
          </ion-button>
        </ion-card-header>
        <ion-card-content>
          <ion-list>
            <ion-item>
              <ion-label class="input-label">Tool</ion-label>
              <ion-button *ngIf="!tool.automationId" color="light" (click)="selectAutomation(tool)" slot="end">
                <ion-icon name="flash-outline" class="padded-icon button-icon"></ion-icon>
                Select an automation
                <ion-icon name="chevron-down-outline" class="icon-padded-left button-icon"></ion-icon>
              </ion-button>
              <ion-button *ngIf="tool.automationId" color="light" (click)="selectAutomation(tool)" slot="end">
                <ion-icon name="flash-outline" class="padded-icon button-icon"></ion-icon>
                {{ tool?.automation?.name ?? 'Automation' }}
              </ion-button>
            </ion-item>

            <ion-item>
              <ion-label class="input-label">Description</ion-label>
              <ion-input [(ngModel)]="tool.description" slot="end"></ion-input>
            </ion-item>

            <ion-item>
              <ng-container>
                <ion-label class="input-label">Approver</ion-label>
                <ion-button *ngIf="tool.approverId" color="light" (click)="removeEntity(tool)" slot="end">
                  <ion-avatar class="user-photo">
                    <app-avatar size="25" [name]="tool.approver?.name" [image]="tool?.approver?.photo"></app-avatar>
                  </ion-avatar>
                  {{ tool.approver?.name }}
                  <ion-icon
                    name="close-circle-outline"
                    style="margin-left: 25px"
                    class="padded-icon button-icon"
                  ></ion-icon>
                </ion-button>
                <ion-button *ngIf="!tool.approverId" color="light" (click)="selectEntity(tool)" slot="end">
                  Select
                </ion-button>
              </ng-container>
            </ion-item>
          </ion-list>
        </ion-card-content>
      </ion-card>
      <ion-button (click)="addNewTool()" color="light">
        <ion-icon name="add"></ion-icon>
        Add new integration</ion-button
      >
    </ion-card-content>
  </ion-card>
</ion-content>

<ion-footer class="footer">
  <ion-button (click)="submit()" [disabled]="isLoading">
    Save
    <ion-spinner name="crescent" [hidden]="!isLoading" style="margin-left: 10px"></ion-spinner>
  </ion-button>
  <ion-button
    fill="clear"
    color="dark"
    (click)="duplicate()"
    [disabled]="isLoading"
    *ngIf="id"
    ngxTippy
    data-tippy-content="Duplicate"
    style="margin-left: 10px"
  >
    <ion-icon name="copy-outline"></ion-icon>
  </ion-button>
  <ion-button
    fill="clear"
    color="dark"
    (click)="moveProject()"
    [disabled]="isLoading"
    *ngIf="id"
    ngxTippy
    data-tippy-content="Move project"
  >
    <ion-icon name="log-out-outline"></ion-icon>
  </ion-button>
  <ion-button
    fill="clear"
    color="dark"
    (click)="delete()"
    [disabled]="isLoading"
    *ngIf="id"
    ngxTippy
    data-tippy-content="Delete"
  >
    <ion-icon name="trash-outline"></ion-icon>
  </ion-button>
</ion-footer>
